module.exports = __webpack_public_path__ + "static/media/banner-homepage-3.1b7ca3db.jpg";